import React from 'react';
import SetUpFunctional from './component/setup-functional';
import './setup-company-setting.scss';

const SetUpCompanyMain = () => {
	return <SetUpFunctional />;
};

export default SetUpCompanyMain;
